import { createAction } from '@reduxjs/toolkit'

import { StatusBannerData } from 'utils/types'

// tryGetStatusBanner
export const get = createAction('get_status_banner')
export const getSuccess = createAction<{ data: StatusBannerData[] }>(
  'get_status_banner_success'
)
export const getFailed = createAction('get_status_banner_failed')
